import { render, staticRenderFns } from "./detalleCertificado.vue?vue&type=template&id=bd0b79cc&scoped=true"
import script from "./detalleCertificado.vue?vue&type=script&lang=js"
export * from "./detalleCertificado.vue?vue&type=script&lang=js"
import style0 from "./detalleCertificado.vue?vue&type=style&index=0&id=bd0b79cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0b79cc",
  null
  
)

export default component.exports